import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pointer",on:{"click":_vm.onChange}},[(_vm.value==='asc')?_c(VIcon,{attrs:{"small":_vm.small}},[_vm._v("mdi-sort-ascending")]):_c(VIcon,{attrs:{"small":_vm.small}},[_vm._v("mdi-sort-descending")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }